const updatesData = [
  { date: '2025-07-30', title: '《封神第二部》高清版正式上线', tag: '新片上线' },
  { date: '2025-07-29', title: '小草影院移动端播放器全新升级，支持手势控制', tag: '功能更新' },
  { date: '2025-07-28', title: '暑期档专题"2025必看大片"合集发布', tag: '专题上线' },
  { date: '2025-07-26', title: '经典港片修复系列新增 50 部周星驰作品', tag: '内容扩充' },
  { date: '2025-07-24', title: '全站 CDN 加速节点扩展至 350+ 城市', tag: '性能优化' },
  { date: '2025-07-22', title: '《流浪地球3》独家幕后纪录片上线', tag: '独家内容' },
  { date: '2025-07-20', title: '动漫专区全新改版，新海诚作品全集上线', tag: '专区更新' },
  { date: '2025-07-18', title: '小草影院日活跃用户突破 500 万', tag: '平台里程碑' },
  { date: '2025-07-15', title: '悬疑片单"烧脑之夜"专题上线，精选 30 部高分佳作', tag: '精选推荐' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500">小草影院的平台动态、内容更新与功能升级，随时掌握最新变化。</p>
        </div>

        <div className="relative pl-8 md:pl-0">
          <div className="absolute left-3 md:left-[calc(50%-1px)] top-0 bottom-0 w-[2px] bg-background-200"></div>

          <div className="space-y-8">
            {updatesData.map((item, i) => (
              <div key={i} className={`relative flex flex-col md:flex-row gap-5 md:gap-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <time className="text-xs font-medium text-foreground-400">{item.date}</time>
                  <h3 className="text-sm font-medium text-foreground-900 mt-1">{item.title}</h3>
                  <span className="inline-block mt-2 px-2 py-0.5 rounded-md text-[10px] font-medium bg-accent-100 text-accent-700">
                    {item.tag}
                  </span>
                </div>
                <div className="hidden md:flex w-5 justify-center shrink-0 relative z-10">
                  <div className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50 mt-1.5"></div>
                </div>
                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}